import Image from 'next/image'
import { DesktopLogo, MobileLogo, MinimalImageWrapper } from './VirginTopbar.styles'

import Link from 'next/link'
import Container from '@/components/Container'

const VirginMinimalTopbar = () => {
  return (
    <>
      <Container noSpacingTop noSpacingBottom>
        <MinimalImageWrapper>
          <Link href="https://www.virginaustralia.com/au/en/#/" target="_blank">
            <DesktopLogo>
              <Image src={`/logos/virgin-logo-dark.svg`} alt="Virgin Australia" width={136} height={40} />
            </DesktopLogo>
            <MobileLogo>
              <Image src={`/logos/virgin-logo-dark.svg`} alt="Virgin Australia" width={100} height={30} />
            </MobileLogo>
          </Link>
          <Link href="https://www.velocityfrequentflyer.com/" target="_blank">
            <DesktopLogo>
              <Image src={`/logos/velocity-logo-dark.svg`} alt="Velocity Frequent Flyer" width={116} height={40} />
            </DesktopLogo>
            <MobileLogo>
              <Image src={`/logos/velocity-logo-dark.svg`} alt="Velocity Frequent Flyer" width={100} height={30} />
            </MobileLogo>
          </Link>
        </MinimalImageWrapper>
      </Container>
    </>
  )
}

export default VirginMinimalTopbar
